module.exports = __webpack_public_path__ + "static/media/en.a66ce267.svg";